import { useReduxState } from 'hooks';
import { DropdownLink } from 'components/common/dropdown';

interface Props {
  completionId: number;
  courseSlug: string;
  courseVersion: string;
}

const CourseViewVersion = ({
  completionId,
  courseSlug,
  courseVersion
}: Props) => {
  const { messages } = useReduxState();

  return (
    <DropdownLink
      category="transparent"
      href={`/courses/${courseSlug}?completionId=${completionId}&version=${Date.parse(
        courseVersion
      )}`}
      icon="eye"
      text={messages.completionCourseViewCompletion}
      tooltip={messages.completionCourseViewCompletionTooltip}
    />
  );
};

export default CourseViewVersion;
